import { render, staticRenderFns } from "./SelectionGrid.vue?vue&type=template&id=27c073e4&scoped=true&"
import script from "./SelectionGrid.vue?vue&type=script&lang=ts&"
export * from "./SelectionGrid.vue?vue&type=script&lang=ts&"
import style0 from "./SelectionGrid.vue?vue&type=style&index=0&id=27c073e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c073e4",
  null
  
)

export default component.exports